import { userConstants,authConstants, alertConstants} from '../_constants'
import { userService } from '../_services'
import { alertActions } from '.'
import { history } from '../_helpers'

export const userActions = {
  login,
  logout,
  register,
  addUser,
  getAll,
  delete: _delete,
  getCurrentUserDetail,
  getCurrentToken,
  forgotPassword,
  resetPasswordValid,
  resetPasswordChange,
  getUserByPage,
  activeUser,
  clearAllMessages,
  getUserById,
  updateUser,
  checkOldAndNewPassword,
  getJustLookingUserById,
  checkOldAndNewPasswordMaptoolx,
  getCurrentUser,
  logoutSession

}

function logoutSession(isLogout){
  return dispatch => {
    dispatch(success(isLogout))
  }
  function success(isLogout) { return { type: userConstants.LOGOUT_SESSION,isLogout } }
}

function forgotPassword(emailAddress) {
  return dispatch => {
    dispatch(request({ emailAddress }))

    userService.forgotPassword(emailAddress)
      .then(
        user => {
          console.log(user)
          if(user.message !== 'success'){
            dispatch(failure({error:'error in forgot password'}))
          }else
            dispatch(success(user))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }

  function request(user) { return { type: userConstants.FORGET_PASSWORD_REQUEST, user } }
  function success(user) { return { type: userConstants.FORGET_PASSWORD_SUCCESS, user } }
  function failure(error) { return { type: userConstants.FORGET_PASSWORD_FAILURE, error } }
}

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }))

    userService.login(username, password)
      .then(
        user => {
          console.log(user)
          if(user.token !== ''){
            dispatch(success(user))
          }else {
            dispatch(failure(user))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function resetPasswordValid(objRequest) {
  console.log(objRequest)
  return dispatch => {
    dispatch(request(objRequest))

    userService.resetPasswordValid(objRequest)
      .then(
        response => {
          console.log(response)
          if(response.message === 'success'){
            dispatch(success(response))
          }else {
            dispatch(failure(response))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }

  function request(user) { return { type: userConstants.RESET_PASSWORD_REQUEST, user } }
  function success(user) { return { type: userConstants.RESET_PASSWORD_SUCCESS, user } }
  function failure(error) { return { type: userConstants.RESET_PASSWORD_FAILURE, error } }
}

function resetPasswordChange(objRequest) {
  return dispatch => {
    dispatch(request(objRequest))

    userService.resetPasswordChange(objRequest)
      .then(
        response => {
          console.log(response)
          if(response.message === 'success'){
            dispatch(success(response))
          }else {
            dispatch(failure(response))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }

  function request(user) { return { type: userConstants.RESET_PASSWORD_REQUEST, user } }
  function success(user) { return { type: userConstants.RESET_PASSWORD_SUCCESS, user } }
  function failure(error) { return { type: userConstants.RESET_PASSWORD_FAILURE, error } }
}

function register(user) {
  return dispatch => {
    dispatch(request(user))

    userService.register(user)
      .then(
        user => {
          dispatch(success(user))
          history.push('/dashboard/login')
          dispatch(alertActions.success('Registration successful'))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }

  function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
  function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
  function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function getAll() {
  return dispatch => {
    dispatch(request())

    userService.getAll()
      .then(
        users => dispatch(success(users)),
        error => dispatch(failure(error.toString()))
      )
  }

  function request() { return { type: userConstants.GETALL_REQUEST } }
  function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
  function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id))

    userService.delete(id)
      .then(
        user => dispatch(success(id)),
        error => dispatch(failure(id, error.toString()))
      )
  }

  function request(id) { return { type: userConstants.DELETE_REQUEST, id } }
  function success(id) { return { type: userConstants.DELETE_SUCCESS, id } }
  function failure(id, error) { return { type: userConstants.DELETE_FAILURE, id, error } }
}

function getCurrentUserDetail(){
  return {token:localStorage.getItem(authConstants.TOKEN_KEY), userName:localStorage.getItem(authConstants.USER_NAME)}
}

function getCurrentToken(){
  return localStorage.getItem(authConstants.TOKEN_KEY)
}

function getCurrentUser(){
  return localStorage.getItem(authConstants.USERID)
}


function logout() {
  userService.logout()
  // remove user from local storage to log user out
  localStorage.removeItem(authConstants.TOKEN_KEY)
  localStorage.removeItem(authConstants.USER_NAME)
  return { type: userConstants.LOGOUT }
}
function getUserByPage(start,pageSize,search) {
  return dispatch => {
    dispatch(request())
    userService.getUserByPage(start,pageSize,search)
      .then(
        users => {
          console.log('users' + users)
          if(users.data)
            dispatch(success(users))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(users) { return { type: userConstants.GETALL_PAGE_REQUEST, users } }
  function success(users) { return { type: userConstants.GETALL_PAGE_SUCCESS, users } }
  function failure(error) { return { type: userConstants.GETALL_PAGE_FAILURE, error } }
}

function activeUser(id, isActive) {
  return dispatch => {
    dispatch(request(id))
    userService.activeUser(id, isActive)
      .then(
        response => {
          console.log(response)
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(response) { return { type: userConstants.ACTIVE_REQUEST, response } }
  function success(response) { return { type: userConstants.ACTIVE_SUCCESS, response } }
  function failure(error) { return { type: userConstants.ACTIVE_FAILURE, error } }
}
function addUser(user) {
  return dispatch => {
    console.log( user)
    dispatch(request(user))
    userService.addUser(user)
      .then(
        user => {
          console.log(user)
          dispatch(success(user))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: userConstants.ADD_REQUEST, user } }
  function success(user) { return { type: userConstants.ADD_SUCCESS, user } }
  function failure(error) { return { type: userConstants.ADD_FAILURE, error } }
}
function clearAllMessages()
{
  return dispatch => {
    dispatch(request())
  }
  function request() { return { type: alertConstants.CLEAR } }
}
function getUserById(id,isUser) {
  return dispatch => {
    dispatch(request())

    userService.getUserById(id)
      .then(
        user => {
          console.log(user)
          dispatch(success(user))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: userConstants.GETBYID_REQUEST, user,isUser } }
  function success(user) { return { type: userConstants.GETBYID_SUCCESS, user,isUser } }
  function failure(error) { return { type: userConstants.GETBYID_FAILURE, error } }
}
function updateUser(user,id) {
  return dispatch => {
    dispatch(request(user))
    userService.updateUser(user,id)
      .then(
        user => {
          console.log('user' + user)
          if(user.message)
            dispatch(success(user))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: userConstants.UPDATE_REQUEST, user } }
  function success(user) { return { type: userConstants.UPDATE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.UPDATE_FAILURE, error } }
}

function checkOldAndNewPassword(currentUserId,backOfficeOldPassword,backOfficeNewPassword) {
  return dispatch => {
    dispatch(request(backOfficeNewPassword))
    userService.checkOldAndNewPassword(currentUserId,backOfficeOldPassword,backOfficeNewPassword)
      .then(
        user => {
          console.log('user' + user)
          if(user.message)
            dispatch(success(user))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: userConstants.BACKOFFICE_REQUEST, user } }
  function success(user) { return { type: userConstants.BACKOFFICE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.BACKOFFICE_FAILURE, error } }
}
function getJustLookingUserById(id) {
  return dispatch => {
    dispatch(request())

    userService.getJustLookingUserById(id)
      .then(
        user => {
          console.log(user)
          dispatch(success(user))
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: userConstants.GETBYID_JUSTLOOKING_REQUEST, user } }
  function success(user) { return { type: userConstants.GETBYID_JUSTLOOKING_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GETBYID_JUSTLOOKING_FAILURE, error } }
}

function checkOldAndNewPasswordMaptoolx(maptoolxFixedId, maptoolxUserName, maptoolxOldPassword, maptoolxNewPassword) {
  return dispatch => {
    dispatch(request(maptoolxNewPassword))
    userService.checkOldAndNewPasswordMaptoolx(maptoolxFixedId, maptoolxUserName, maptoolxOldPassword, maptoolxNewPassword)
      .then(
        user => {
          console.log('user' + user)
          if(user.message)
            dispatch(success(user))
          else {
            dispatch(failure('error'))
          }
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
  }
  function request(user) { return { type: userConstants.MAPTOOLX_REQUEST, user } }
  function success(user) { return { type: userConstants.MAPTOOLX_SUCCESS, user } }
  function failure(error) { return { type: userConstants.MAPTOOLX_FAILURE, error } }
}
